import React, { useState, useEffect, } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, } from "react-bootstrap";
import * as Utils from '../../utils/utils';
import HorizontalSpinner from '../spinner/horizontalspinner';
import { getOTDataAsync, setCurrentAMPRunData } from "../actions/index";
import RenderTable from '../ottable/table';

const OT = () => {
    const state = useSelector(state => state);
    const dispatch = useDispatch();

    const [otTableData, setOtTableData] = useState([]);   


    useEffect(() => {        
        if (state.otlist.length === 0) {
            dispatch(getOTDataAsync(state.jwt));
        }   
        // eslint-disable-next-line react-hooks/exhaustive-deps    
    }, []);

    useEffect(() => {
        if (state.runlist_searched_amp !== undefined && state.runlist_searched_amp.length > 0) {
            const ampListVar = state.runlist_searched_amp.filter(f => f.start !== undefined && f.start !== null).sort(function(a,b){       
                return new Date(b.start) - new Date(a.start);
              }).map(m => {
                return {
                    ...m,                    
                    start: Utils.getStartDate(m.start)
                };
            });
            setOtTableData(ampListVar);           
        }     
       // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.runlist_searched_amp]);   

    useEffect(() => {
        if (state.otlist && state.otlist.length > 0 && state.runlist_searched_amp.length === 0) {
            const ampListVar = state.otlist.filter(f => f.StartDateTime !== undefined && f.StartDateTime !== null).sort(function(a,b){       
                return new Date(b.StartDateTime) - new Date(a.StartDateTime);
              }).map(m => {
                return {
                    ...m,                   
                    start: Utils.getStartDate(m.StartDateTime),
                    reagent: Utils.generateOTReagentsString(m)
                };
            });
            setOtTableData(ampListVar);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.otlist]);   

    const handleTabsSelect = () => {
        dispatch(setCurrentAMPRunData(state.otlist.filter(f => f.runid === state.ampRunId)));
    }

    const handleClearAdvancedSearch = e => {
        try {
            dispatch(getOTDataAsync(state.jwt));
        }
        catch { }
    }

    return (
        <Container fluid>
            <Row>
                <Col lg={12} style={{ marginTop: 15, height: 5 }}>
                    {state.is_amp_data_loading ? <HorizontalSpinner /> : null}
                </Col>
                <Col lg={12} style={{ marginTop: 15 }}>
                    <RenderTable mainTableData={otTableData} handleTabsSelect={handleTabsSelect} handleClearAdvancedSearch={handleClearAdvancedSearch} />                  
                </Col>
            </Row>           
        </Container >
    )
};

export default OT;